import { Application } from "@hotwired/stimulus"
import Datepicker from "stimulus-datepicker"

import TaskCardController from "./task_card_controller"
import EditableFieldController from "./editable_field_controller"
import EditableDateController from "./editable_date_controller"
import CrepeEditorController from "./crepe_editor_controller"
import ThreadPickerController from "./thread_picker_controller"
import NotesListController from "./notes_list_controller"
import NoteCardController from "./note_card_controller"
import AutofocusEndController from "./autofocus_end_controller"
import ScrollToHashController from "./scroll_to_hash_controller"
import NoteSearchController from "./note_search_controller"
import LiveSearchController from "./live_search_controller"
import DialogController from "./dialog_controller"
import SidebarController from "./sidebar_controller"
import MarkdownFormController from "./markdown_form_controller"

export function setupStimulus() {
	window.Stimulus = Application.start()
	Stimulus.register("task-card", TaskCardController)
	Stimulus.register("editable-field", EditableFieldController)
	Stimulus.register("datepicker", Datepicker)
	Stimulus.register("editable-date", EditableDateController)
	Stimulus.register("crepe-editor", CrepeEditorController)
	Stimulus.register("thread-picker", ThreadPickerController)
	Stimulus.register("notes-list", NotesListController)
	Stimulus.register("note-card", NoteCardController)
	Stimulus.register("autofocus-end", AutofocusEndController)
	Stimulus.register("scroll-to-hash", ScrollToHashController)
	Stimulus.register("note-search", NoteSearchController)
	Stimulus.register("live-search", LiveSearchController)
	Stimulus.register("dialog", DialogController)
	Stimulus.register("sidebar", SidebarController)
	Stimulus.register("markdown-form", MarkdownFormController)
}

export default {
	setupStimulus,
}
